// JWT payload olvasása ELLENŐRZÉS NÉLKÜL — csak kliensoldali döntéshez (pl. melyik
// felhasználóé a másik lapon tárolt token). Biztonsági döntést a szerver hoz.

/** A simplejwt `user_id` claim-je szövegként, vagy null, ha nem olvasható. */
export function jwtUserId(token: unknown): string | null {
  if (typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3 || !parts[1]) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const payload: unknown = JSON.parse(atob(padded));
    if (!payload || typeof payload !== 'object') return null;
    const id = (payload as { user_id?: unknown }).user_id;
    return typeof id === 'number' || (typeof id === 'string' && id !== '') ? String(id) : null;
  } catch {
    return null;
  }
}
